import { render, staticRenderFns } from "./teamCom.vue?vue&type=template&id=725497c3&scoped=true&"
import script from "./teamCom.vue?vue&type=script&lang=ts&"
export * from "./teamCom.vue?vue&type=script&lang=ts&"
import style0 from "./teamCom.vue?vue&type=style&index=0&id=725497c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725497c3",
  null
  
)

export default component.exports